import { LinkContext } from '.'


import { useContext } from 'react';
export const useLinkContext = () => {
  const linkContext = useContext(LinkContext)

  return linkContext
}
